import { createSlice } from '@reduxjs/toolkit'
import {
  getAreaWiseInquiryReport,
  getAttendanceReport,
  getBatchFromBranch,
  getCourseFromBranch,
  getDailyReport,
  getExamResultReport,
  getFacultyLectureCountReport,
  getFacultyLectureReport,
  getFeesCollectionReport,
  getFeesDueDetailsReport,
  getInquiryReport,
  getKitDistributionReport,
  getKitSummaryReport,
  getSourceWiseInquiryReport,
  getStudentDetailsReport,
  getTimeTableReport,
} from '../../builders/reports/reports.builder'

const initialState = {
  loading: false,
  pageDropDownLoading: false,
  feesCollectionReportData: [],
  studentDetailsReportData: [],
  feesDetailsReportData: [],
  attendanceReportData: [],
  examResultReportData: [],
  facultyLectureReportData: [],
  facultyLectureCountReportData: [],
  kitDistributionReportData: [],
  sourceWiseInquiryReportData: [],
  batches: [],
  courseByBranchData: [],
  kitSummaryReportData: [],
  timeTableReport: [],
  dailyReport: [],
  inquiryReport: [],
  areaWiseInquiryReport: [],
  mailLoading: false,
}

const reportSlice = createSlice({
  name: 'reports',
  initialState: initialState,
  reducers: {
    setMailLoading: (state, action) => {
      state.mailLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFeesCollectionReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFeesCollectionReport.fulfilled, (state, action) => {
      state.loading = false
      state.feesCollectionReportData = action.payload
    })
    builder.addCase(getFeesCollectionReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getStudentDetailsReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentDetailsReport.fulfilled, (state, action) => {
      state.loading = false
      state.studentDetailsReportData = action.payload
    })
    builder.addCase(getStudentDetailsReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getFeesDueDetailsReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFeesDueDetailsReport.fulfilled, (state, action) => {
      state.loading = false
      state.feesDetailsReportData = action.payload
    })
    builder.addCase(getFeesDueDetailsReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getAttendanceReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getAttendanceReport.fulfilled, (state, action) => {
      state.loading = false
      state.attendanceReportData = action.payload
    })
    builder.addCase(getAttendanceReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getExamResultReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getExamResultReport.fulfilled, (state, action) => {
      state.loading = false
      state.examResultReportData = action.payload
    })
    builder.addCase(getExamResultReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getFacultyLectureReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFacultyLectureReport.fulfilled, (state, action) => {
      state.loading = false
      state.facultyLectureReportData = action.payload
    })
    builder.addCase(getFacultyLectureReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getFacultyLectureCountReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFacultyLectureCountReport.fulfilled, (state, action) => {
      state.loading = false
      state.facultyLectureCountReportData = action.payload
    })
    builder.addCase(getFacultyLectureCountReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getBatchFromBranch.pending, (state) => {
      state.pageDropDownLoading = true
    })
    builder.addCase(getBatchFromBranch.fulfilled, (state, action) => {
      state.pageDropDownLoading = false
      state.batches = action.payload
    })
    builder.addCase(getBatchFromBranch.rejected, (state) => {
      state.pageDropDownLoading = false
    })

    builder.addCase(getKitDistributionReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getKitDistributionReport.fulfilled, (state, action) => {
      state.loading = false
      state.kitDistributionReportData = action.payload
    })
    builder.addCase(getKitDistributionReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getCourseFromBranch.pending, (state) => {
      state.pageDropDownLoading = true
    })
    builder.addCase(getCourseFromBranch.fulfilled, (state, action) => {
      state.pageDropDownLoading = false
      state.courseByBranchData = action.payload
    })
    builder.addCase(getCourseFromBranch.rejected, (state) => {
      state.pageDropDownLoading = false
    })

    builder.addCase(getSourceWiseInquiryReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getSourceWiseInquiryReport.fulfilled, (state, action) => {
      state.loading = false
      state.sourceWiseInquiryReportData = action.payload
    })
    builder.addCase(getSourceWiseInquiryReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getKitSummaryReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getKitSummaryReport.fulfilled, (state, action) => {
      state.loading = false
      state.kitSummaryReportData = action.payload
    })
    builder.addCase(getKitSummaryReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getTimeTableReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getTimeTableReport.fulfilled, (state, action) => {
      state.loading = false
      state.timeTableReport = action.payload
    })
    builder.addCase(getTimeTableReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getDailyReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getDailyReport.fulfilled, (state, action) => {
      state.loading = false
      state.dailyReport = action.payload
    })
    builder.addCase(getDailyReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getInquiryReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getInquiryReport.fulfilled, (state, action) => {
      state.loading = false
      state.inquiryReport = action.payload
    })
    builder.addCase(getInquiryReport.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getAreaWiseInquiryReport.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getAreaWiseInquiryReport.fulfilled, (state, action) => {
      state.loading = false
      state.areaWiseInquiryReport = action.payload
    })
    builder.addCase(getAreaWiseInquiryReport.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { setMailLoading } = reportSlice.actions
export default reportSlice.reducer
